import { KYMW5900Component } from './kymw5900.component';

/**
 * EC企画商品一覧表画面の値を管理するクラス
 *
 * @export KYMW5900Model
 * @class KYMW5900Model
 */
export class KYMW5900Model {

  KYMW5900Component: KYMW5900Component;

  public fileName: string = <string>'';

  // 画面バインド用変数
  public orderCode: string = <string>'';
  public classCode: string = <string>'';
  public mediumType: string = <string>'';
  public entryGoodsDiv: string = <string>'';

  public allCoop: boolean = <boolean> false;
  public ibaraki: boolean = <boolean> false;
  public tochigi: boolean = <boolean> false;
  public gunma: boolean = <boolean> false;
  public chiba: boolean = <boolean> false;
  public saitama: boolean = <boolean> false;
  public tokyo: boolean = <boolean> false;
  public nagano: boolean = <boolean> false;
  public niigata: boolean = <boolean> false;

  /**
   * ファイル名を更新する
   *
   * @param serverData ファイル名のサーバ取得データ
   */
  public updateFileName(serverData: any) {
    this.fileName = serverData.fileName;
  }

}
